import { FC } from "react";
import { Typography } from "@mui/material";

const Logo: FC = () => {
  return <Typography component="span">BARQ</Typography>;
};

export default Logo;
